'use client';

import type { FC } from 'react';
import { TASK_SETTING_OPTION } from '@/app/constants';
import type { ConfigItemOption } from '@/app/types';
import { ToolSettingsWithConfig } from '../../_components/ToolSettingsWithConfig';

interface StyleTransferSettingsProps {
  aspectRatio: string;
  resolution: string;
  sampleCount: number;
  onAspectRatioChange: (value: string) => void;
  onResolutionChange: (value: string) => void;
  onSampleCountChange: (value: number) => void;
}

const ASPECT_RATIO_OPTIONS: ConfigItemOption[] = ['1:1', '16:9', '9:16', '4:3', '3:4'].map((value) => ({
  value,
  label: value,
  showVip: false,
}));

const RESOLUTION_OPTIONS: ConfigItemOption[] = ['1080p', '2k', '4k'].map((value) => ({
  value,
  label: value.toUpperCase(),
  showVip: false,
}));

const SAMPLE_COUNT_OPTIONS: ConfigItemOption[] = ['1', '2', '3', '4'].map((value) => ({
  value,
  label: value,
  showVip: false,
}));

const INCLUDED_OPTIONS = [TASK_SETTING_OPTION.AspectRatio, TASK_SETTING_OPTION.Resolution, TASK_SETTING_OPTION.Amount];

export const StyleTransferSettings: FC<StyleTransferSettingsProps> = ({
  aspectRatio,
  resolution,
  sampleCount,
  onAspectRatioChange,
  onResolutionChange,
  onSampleCountChange,
}) => {
  return (
    <ToolSettingsWithConfig
      className="w-full"
      includedOptions={INCLUDED_OPTIONS}
      aspectRatioOption={{
        value: aspectRatio,
        options: ASPECT_RATIO_OPTIONS,
        onChange: onAspectRatioChange,
      }}
      resolutionOption={{
        value: resolution,
        options: RESOLUTION_OPTIONS,
        onChange: onResolutionChange,
      }}
      amountOption={{
        value: sampleCount,
        options: SAMPLE_COUNT_OPTIONS,
        onChange: onSampleCountChange,
      }}
    />
  );
};
